
import Vue from "vue";
export default Vue.extend({
  props: ["post"],
  methods: {
    selectTab(index: number) {
      this.post.selectedTab = index;
      this.$router.push(this.post.tabs[index].path);
    },
  },
});
